import { render, staticRenderFns } from "./UpsiPersonStrip.vue?vue&type=template&id=1fe933d9"
import script from "./UpsiPersonStrip.vue?vue&type=script&lang=js"
export * from "./UpsiPersonStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports